import { Info } from "lucide-react";
import { useTranslation } from "@/shared/i18n";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/ui/tooltip";

interface Props {
  label: string;
  hint: string;
}

/**
 * Header com ícone de info + tooltip.
 * Espera estar dentro de um `<TooltipProvider>` ancestral.
 * O alinhamento é herdado do `<TableHead>` (`text-right`/`text-left`).
 */
export function HeaderWithTooltip({ label, hint }: Props) {
  const { t } = useTranslation("common");
  return (
    <span className="inline-flex items-center gap-1.5">
      {label}
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex h-4 w-4 items-center justify-center rounded text-muted-foreground hover:text-foreground focus:outline-none focus:ring-1 focus:ring-ring"
            aria-label={t("moreInfo", "Mais informações")}
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs">
          {hint}
        </TooltipContent>
      </Tooltip>
    </span>
  );
}
